'use no memo'

import { Button } from '@repo/ui/components'
import { Column } from '@tanstack/react-table'
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react'

import { cva, VariantProps } from 'class-variance-authority'

const headerVariants = cva('flex gap-px items-center transition-colors', {
  variants: {
    isSorted: {
      true: 'text-foreground',
      false: '',
    },
    align: {
      left: 'justify-start',
      right: 'justify-end',
      center: 'justify-center',
    },
  },
  defaultVariants: {
    isSorted: false,
    align: 'left',
  },
})

type HeaderProps<T> = {
  column: Column<T>
  sortable?: boolean
} & VariantProps<typeof headerVariants>

export function TableHeader<T>(props: HeaderProps<T>) {
  const handleSort = () => {
    const isAscending = props.column.getIsSorted() === 'asc'
    const isDescending = props.column.getIsSorted() === 'desc'

    if (isDescending) {
      props.column.clearSorting()
    } else {
      props.column.toggleSorting(isAscending)
    }
  }

  const displayTitle = props.column.columnDef.meta?.displayTitle

  const IconForSort = () => {
    const currentSort = props.column.getIsSorted()
    if (currentSort === 'asc') return <ArrowUpIcon className="size-4" />
    if (currentSort === 'desc') return <ArrowDownIcon className="size-4" />
    return <ArrowUpDownIcon className="size-4" />
  }

  return (
    <div
      className={headerVariants({
        align: props.align,
        isSorted: props.column.getIsSorted() !== false,
      })}
    >
      {displayTitle}
      {props.sortable && (
        <Button variant="ghost" size="icon-sm" onClick={handleSort} className="-mr-2 size-7">
          {IconForSort()}
        </Button>
      )}
    </div>
  )
}
